// extracted by mini-css-extract-plugin
module.exports = {"role-assignment":"role-assignment--27PpDQoBk2","roleAssignment":"role-assignment--27PpDQoBk2","disabled":"disabled--2oHRn207BS","locale":"locale--3ItcH-LAQO"};